<template>
<section class="qc-statistics-chart-wrapper">
  <e-chart ref="chart" style="height:328px;" />

  <div class="limit-input-wrapper">
    <span style="font-size:.7em;display:inline-block;line-height:28px;vertical-align:middle;">控制限值:</span>
    <el-input
      v-model="limit"
      placeholder="控制限值"
      type="number"
      size="mini"
      style="width:100px;"
      @change="onLimitChange"
      @keydown.native.enter="onLimitChange"
    />
  </div>

  <section class="summary-wrapper">
    <section>控制限值：{{realLimit}}%</section>
    超出范围{{errorCount}}天，占比{{(errorRatio * 100).toFixed(2)}}%
  </section>
</section>
</template>

<script>
export default {
  name: 'NonconformityChart',
  props: {
    qcType: {
      required: true,
      type: Object
    },
    dateRange: Array,
    summaries: Array
  },
  data () {
    return {
      limit: 0,
      realLimit: 0,
      errorCount: 0,
      errorRatio: 0
    }
  },
  computed: {
    summaryMap () {
      return this.summaries.reduce((map, summary) => {
        map[summary.dataTime] = summary.error / summary.total * 100
        return map
      }, {})
    }
  },
  methods: {
    render () {
      let {dateList, completeDataList, realLimit} = this
      this.calcSummary(completeDataList, realLimit)
      let chartOpt = {
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis',
          appendToBody: true,
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: 'rgba(0, 0, 0, .5)'
            }
          }
        },
        legend: {
          top: 35,
          data: ['超差率'],
          left: 'center',
          textStyle: {
            padding: [3, 0, 3, 0]
          },
          type: 'scroll'
        },
        grid: {
          top: 70,
          right: 20,
          bottom: 0,
          left: 0,
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: dateList,
          axisTick: {
            show: false
          },
          axisLine: {
            onZero: false
          },
          axisLabel: {
            interval: 0,
            rotate: 90,
            textStyle: {
              color: '#000'
            }
          }
        }],
        yAxis: {
          type: 'value',
          // scale: true,
          axisLabel: {
            formatter: `{value}%`,
            margin: 15,
            textStyle: {
              color: '#000'
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#D8E8FF'
            }
          }
        },
        series: [{
          name: '超差率',
          type: 'bar',
          data: completeDataList.map(percentage => isNaN(percentage) ? NaN : parseFloat(percentage.toFixed(2))),
          color: 'rgb(102, 205, 170)',
          label: {
            show: true,
            position: 'insideBottom',
            rotate: 90,
            distance: 25,
            verticalAlign: 'middle',
            color: '#000',
            formatter: '{c}%'
          }
        }, {
          name: '控制线',
          type: 'line',
          data: dateList.map(() => realLimit),
          color: 'red',
          symbol: 'none',
          lineStyle: {
            type: 'dashed',
            width: 1
          }
        }]
      }

      this.$refs.chart.setOpt(chartOpt, true)
    },
    getDateList () {
      let [beginTime, endTime] = this.dateRange
      let endTS = new Date(endTime.replace(/-/g, '/')).getTime()
      let dateList = []

      for (beginTime = new Date(beginTime.replace(/-/g, '/')); beginTime.getTime() <= endTS; beginTime.setDate(beginTime.getDate() + 1)) {
        dateList.push(beginTime.format('YYYY-MM-DD'))
      }

      return dateList
    },
    getCompleteDataList () {
      let {dateList, summaryMap} = this

      return dateList.map(date => {
        let value = summaryMap[date]

        if (!Number.isFinite(value)) {
          value = NaN
        }

        return value
      })
    },
    calcSummary (dataList, limit) {
      this.errorRatio = (this.errorCount = dataList.reduce((count, data) => count + (data > limit), 0)) / dataList.length
    },
    onLimitChange () {
      this.realLimit = this.limit
      this.render()
    }
  },
  watch: {
    dateRange: {
      immediate: true,
      handler (newVal) {
        this.dateList = this.getDateList()
      }
    },
    qcType: {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          this.limit = this.realLimit = newVal.statistics.defaultCtrlVal
        }
      }
    },
    summaryMap: {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          this.completeDataList = this.getCompleteDataList()
          setTimeout(this.render, 0)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.qc-statistics-chart-wrapper {
  position: relative;

  .limit-input-wrapper {
    position: absolute;
    top: 10px;
  }

  .summary-wrapper {
    font-size: .7em;
    margin-top: 20px;
    line-height: 24px;
    user-select: all;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/05QC-Analysis/00Data/NonconformityChart.vue